module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._l((_vm.slides), function(slide, index) {
    return _c('div', {
      key: index,
      staticClass: "mySlides",
      style: ({
        display: _vm.slideIndex === index + 1 ? 'block' : 'none'
      })
    }, [_c('div', {
      staticClass: "numbertext"
    }, [_vm._v(_vm._s(index + 1) + " / " + _vm._s(_vm.slides.length))]), _vm._v(" "), _c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": slide
      }
    })])
  }), _vm._v(" "), (_vm.slides.length > 1) ? _c('div', [_c('a', {
    staticClass: "prev",
    on: {
      "click": function($event) {
        return _vm.plusSlides(-1)
      }
    }
  }, [_vm._v("❮")]), _vm._v(" "), _c('a', {
    staticClass: "next",
    on: {
      "click": function($event) {
        return _vm.plusSlides(1)
      }
    }
  }, [_vm._v("❯")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.slides), function(slide, index) {
    return _c('div', {
      key: 'thumb-' + index,
      staticClass: "column"
    }, [_c('img', {
      staticClass: "demo cursor",
      class: {
        active: _vm.slideIndex === index + 1
      },
      staticStyle: {
        "width": "100%",
        "height": "150px",
        "padding": "0 3px"
      },
      attrs: {
        "src": slide
      },
      on: {
        "click": function($event) {
          return _vm.currentSlide(index + 1)
        }
      }
    })])
  }), 0)]) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-container"
  }, [_c('p', {
    attrs: {
      "id": "caption"
    }
  }, [_vm._v("List Images")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e9e742ea","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/claim/SliderClaimImages.vue
// module id = 1859
// module chunks = 1